export const iconFontAwesomeHouseholdFaucet = (
	<i className="fa-solid fa-faucet"></i>
);
